import dialog from "../../../../components/Modal/dialog";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Progress from "../../../../components/Progress";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import FormUtils from "../../../../utils/classUtils/FormUtils";
import createPromise from "../../../../utils/createPromise";
import withRouter from "../../../../utils/withRouter";
import Card from "../../negative-records/negative-records-view/components/Card";
import ApproveRequestModal from "./components/ApproveRequestModal";
import DetailCard from "./components/DetailCard";
import { approveDetails } from "./data/approveDetails";
import { lockDetails } from "./data/lockDetails";
import { requestorDetails } from "./data/requestorDetails";
import UnlockingDetailsPresenter from "./UnlockingDetailsPresenter";

class UnlockingDetailsPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, access: [], modalState: false };
    this.presenter = new UnlockingDetailsPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase(),
    );
  }

  getCollectionName() {
    return "access_request";
  }

  handleApproveRequestClick() {
    // alert("sdsd");
    this.presenter.handleApproveRequestClick();
  }

  showApproveRequestModal() {
    const promise = createPromise();
    dialog.fire({
      html: <ApproveRequestModal onRemarksChange={this.onChange.bind(this)} />,
      positiveButton: "Approve Request",
      // negativeButton: "Cancel",
      onPositiveClick: () => {
        promise.resolve();
      },
      // onNegativeClick: () => {
      //   promise.reject();
      // },
    });

    return promise;
  }

  setAccessHistory(access) {
    this.setState({ access });
  }

  render() {
    const { object, access } = this.state;

    console.log("obs", object);
    const user = this.getCurrentUser();

    const accessHistoryHeader = [
      "Affiliate",
      "Branch",
      "Username",
      "Full Name",
      "Search Date",
      "LOCK(Y/N)",
    ];

    const lockedUsername =
      object?.no_record_requested?.username?.trim()?.toLowerCase() ||
      object?.prev_record_requested?.prev?.lockedTo?.username
        ?.trim()
        ?.toLowerCase();

    const accessHistoryBody = access.map((history) => {
      const { accessor } = history || {};
      console.log("cccc", accessor);
      const accessorUsername = accessor?.username?.trim()?.toLowerCase();
      const lockStatus =
        lockedUsername && accessorUsername === lockedUsername ? "Y" : "N";

      const formatToPhilippineTime = (date) => {
        return new Intl.DateTimeFormat("en-US", {
          timeZone: "Asia/Manila",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }).format(new Date(date));
      };

      const dateDisplay = history?.searchDT
        ? formatToPhilippineTime(history.searchDT)
        : formatToPhilippineTime(history.createdAt);
      // return [
      //   accessor.affiliate?.name,
      //   accessor.branch?.name,
      //   accessor.username,
      //   `${accessor?.firstName || ""} ${accessor?.middleName || ""} ${accessor?.lastName || ""}`,
      //   dateDisplay,
      //   lockStatus,
      // ];
      return [
        accessor.affiliate?.name,
        accessor.branch?.name,
        accessor.username,
        `${accessor?.firstName || ""} ${accessor?.middleName || ""} ${accessor?.lastName || ""}`.trim() ||
          accessor?.id,
        dateDisplay,
        lockStatus,
      ];
    });

    console.log("ob", object);

    if (Object.keys(object).length < 1) {
      return <Progress />;
    }

    return (
      // <PageContainer
      //   title="Unlocking Details"
      //   navigateBack={() => this.navigateBack()}
      //   {...((object.status !== "Request Granted" &&
      //     user.id === object.approverName) ||
      //   (object.status !== "Request Granted" &&
      //     object.status !== "Cancelled" &&
      //     user.roles?.some((role) => role.id === "admin")) // Check if user has admin role
      //     ? {
      //         rightButtonHandler: this.handleApproveRequestClick.bind(this),
      //         rightButtonLabel: "Approve Lock Request",
      //       }
      //     : {})}
      // >
      <PageContainer
        title="Unlocking Details"
        navigateBack={() => this.navigateBack()}
        {...((object.status !== "Request Granted" &&
          object.status !== "Cancelled" &&
          user.id === object.approverName) ||
        (object.status !== "Request Granted" &&
          object.status !== "Cancelled" &&
          user.roles?.some((role) => role.id === "admin")) // Check if user has admin role
          ? {
              rightButtonHandler: this.handleApproveRequestClick.bind(this),
              rightButtonLabel: "Approve Lock Request",
            }
          : {})}
      >
        <div className="d-flex flex-column gap-4 mt-3">
          <DetailCard title="Lock Information" info={lockDetails(object)} />
          <DetailCard
            title="Requestor Details"
            info={requestorDetails(object)}
            file={object}
          />
          {object?.approveDetails && (
            <DetailCard title="Approve Details" info={approveDetails(object)} />
          )}
          <Card
            header={accessHistoryHeader}
            body={accessHistoryBody}
            label="Access History"
            // rightButtonLabel="View All"
            // rightButtonHandler={this.handleViewAllAccessHistory.bind(this)}
          />
        </div>
      </PageContainer>
    );
  }
}

export default withRouter(UnlockingDetailsPage);
